import angular from 'angular';
import ngRoute from 'angular-route';
import routes from './home.routes';
import newsCarousel from './newsCarousel';
import theSafeHome from './theSafeHome';


export default angular.module('app.components.home', [
  ngRoute,
  newsCarousel,
  theSafeHome
])
  .config(routes)
  .name;

console.log('app.components.home created');
